import { TicketSaleTrigger as GqlTrigger } from '../../../generated/api.graphql';

/** What puts a ticket on sale; wrapped because `@vp/admin` cannot import generated types. */
export const TicketSaleTrigger = Object.freeze({
  WINDOW: GqlTrigger.Window,
  DEPENDENCY: GqlTrigger.Dependency,
});
export type TicketSaleTrigger = (typeof TicketSaleTrigger)[keyof typeof TicketSaleTrigger];
